//import { useEffect } from 'react';
import { useI18n } from '@/i18n';
import { useAuthStore } from '@/store/authStore';
//import { useOrderStore } from '@/store/orderStore';
import { useNavigate } from 'react-router-dom';
import { 
  RiCoupon2Line, 
  RiMapPin2Line, 
  RiHeartLine, 
  RiCustomerService2Line, 
  RiShieldCheckLine, 
  RiArrowRightSLine,
  //RiShoppingBag3Line,
  //RiLogoutBoxRLine,
  RiLogoutCircleRLine,
  RiUser3Line,
  RiRefund2Line
} from 'react-icons/ri';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

export function Account() {
  const { currentLang } = useI18n();
  const { profile, user, signOut } = useAuthStore();
  //const { totalOrders, fetchMyOrders } = useOrderStore();
  const navigate = useNavigate();

  /*useEffect(() => {
    if (user) {
      // Fetch full page so the shared Zustand `orders` array is never stale
      // with a partial result (previously limit=1 caused Orders page to show only 1 order)
      fetchMyOrders(user.id, 1, 20);
    }
  }, [user, fetchMyOrders]);*/

  if (!user) {
    navigate('/login');
    return null;
  }

  const menuItems = [
    { 
      label: currentLang === 'bn' ? 'কুপন' : 'Coupons', 
      icon: RiCoupon2Line, 
      onClick: () => navigate('/coupons') 
    },
    { 
      label: currentLang === 'bn' ? 'ঠিকানা' : 'Addresses', 
      icon: RiMapPin2Line, 
      onClick: () => navigate('/address'),
    },
    { 
      label: currentLang === 'bn' ? 'উইশলিস্ট' : 'Wishlist', 
      icon: RiHeartLine, 
      onClick: () => navigate('/wishlist') 
    },
    { 
      label: currentLang === 'bn' ? 'হেল্প সেন্টার' : 'Help Center', 
      icon: RiCustomerService2Line, 
      onClick: () => navigate('/account/help') 
    },
    { 
      label: currentLang === 'bn' ? 'রিফান্ড পলিসি' : 'Refund Policy', 
      icon: RiRefund2Line, 
      onClick: () => navigate('/account/refund') 
    },
    { 
      label: currentLang === 'bn' ? 'প্রাইভেসি পলিসি' : 'Privacy Policy', 
      icon: RiShieldCheckLine, 
      onClick: () => navigate('/account/privacy') 
    },
  ];

  return (
    <div className="min-h-[100dvh] bg-white font-sans">
      <div className="animate-fade-in pb-24 lg:pb-10">
        {/* Premium Header — Gold Standard */}
        <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-xl border-b border-gray-100/50 shadow-[0_4px_20px_rgba(0,0,0,0.03)] transition-all">
          <div className="max-w-2xl mx-auto px-4 py-4 flex items-center justify-center">
            <h1 className="text-lg font-black tracking-tight text-center">
              {currentLang === 'bn' ? 'একাউন্ট' : 'Account'}
            </h1>
          </div>
        </header>

        {/* Profile Card */}
        <div className="flex flex-col items-center px-6 pt-4 pb-2">
          <Avatar className="h-20 w-20 shadow-lg border-2 border-white ring-1 ring-gray-100">
            <AvatarImage src={profile?.avatar_url || ''} className="object-cover" />
            <AvatarFallback className="bg-gray-100 text-gray-400">
              <RiUser3Line size={32} />
            </AvatarFallback>
          </Avatar>
          
          <h2 className="mt-2 text-lg font-bold text-black tracking-tight">
            {profile?.full_name || (currentLang === 'bn' ? 'ব্যবহারকারী' : 'User')}
          </h2>
          
          <p className="text-xs text-black mt-0.5">+88 {profile?.phone || ''}</p>

          <div className="flex items-center gap-2 mt-3">
            {/*<div className="flex items-center bg-white shadow-sm shadow-black/25 px-3 py-1.5 rounded-full">
              <RiShoppingBag3Line className="h-4 w-4 text-black mr-2" />
              <span className="text-sm font-bold text-black mr-1 mt-0.5">{totalOrders}</span>
              <span className="text-sm text-black uppercase font-medium tracking-tighter">
                {currentLang === 'bn' ? 'টি অর্ডার' : 'Orders'}
              </span>
            </div>*/}
            <button
              onClick={() => navigate('/profile')}
              className="text-white text-[13px] font-bold bg-primary shadow-sm shadow-black/25 rounded-full px-3 py-1.5"
            >
              {currentLang === 'bn' ? 'প্রোফাইল দেখুন' : 'View Profile'}
            </button>
          </div>
        </div>

        {/* Menu Options */}
        <div className="px-4 mt-2 space-y-0.5">
          {menuItems.map((item) => (
            <button
              key={item.label}
              onClick={item.onClick}
              className="w-full flex items-center justify-between px-3 py-3 bg-white hover:bg-gray-100 rounded-xl transition-all group"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full shadow-sm shadow-black/25 bg-primary transition-all">
                  <item.icon className="w-5 h-5 text-white" />
                </div>
                <span className="font-bold text-[14.5px] text-black tracking-tight">{item.label}</span>
              </div>
              <RiArrowRightSLine className="w-5 h-5 text-primary" />
            </button>
          ))}

          <button
            onClick={signOut}
            className="w-full flex items-center justify-between p-3 mt-1.5 bg-white hover:bg-red-50/10 rounded-xl transition-all group"
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full shadow-sm shadow-black/25 bg-red-600 transition-all">
                <RiLogoutCircleRLine className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold text-[14.5px] text-red-500 lg:text-black lg:group-hover:text-red-500 transition-colors tracking-tight">
                {currentLang === 'bn' ? 'লগ আউট' : 'Log out'}
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
